import type { ReactNode } from 'react';

interface CardProps {
  title?: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}

export default function Card({ title, subtitle, actions, children, className = '', bodyClassName = '' }: CardProps) {
  const hasHeader = Boolean(title || subtitle || actions);

  return (
    <div className={`card p-0 overflow-hidden ${className}`}>
      {hasHeader && (
        <div className="p-6 border-b border-border flex items-start justify-between gap-4">
          <div>
            {title && <h3 className="text-lg font-semibold text-text-header">{title}</h3>}
            {subtitle && <p className="mt-1 text-sm text-text-muted">{subtitle}</p>}
          </div>
          {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
        </div>
      )}
      <div className={`p-6 ${bodyClassName}`}>{children}</div>
    </div>
  );
}
